import { getBrowserTimezone } from '~/lib/DateTime';
import { useEffect } from 'react';
import useClientTimezone from '~/public/lib/useClientTimezone.js';

export function getSingleEventValue(value) {
    return Array.isArray(value) ? value[0] : value;
}

export function numberBookableResourcesRequiredFromId(eventTypeId, allTypes) {
    const eventType = allTypes.find(t => t.id === eventTypeId);

    if (!eventType) {
        return 1;
    }

    return Math.max(
        1,
        eventType?.settings?.numberBookableResourcesRequired || 1,
    );
}

export function useSchedulingValue({
    setValue,
    value,
    setQuantity,
    quantity,
    capacity,
    settings,
}) {
    const clientTz = useClientTimezone();
    const defaultQuantity = settings?.requireExplicitQuantity ? 0 : 1;

    function getDistinctEvents(old) {
        old = Array.isArray(old) ? old : [old];
        function getKey(item) {
            console.log('item=', item);
            return `${item?.bookableResource}-${item?.eventType}-${item?.startTime}`;
        }

        return [...new Map(old.map(item => [getKey(item), item])).values()];
    }

    function update(newData) {
        setValue(old => {
            const distinctValues = getDistinctEvents(old);

            const quantityData =
                quantity === 0
                    ? { zeroQuantity: true }
                    : { zeroQuantity: false };

            const newEventData = [];
            for (let single of distinctValues) {
                newEventData.push({
                    clientTimezone: clientTz,
                    ...single,
                    ...newData,
                    ...quantityData,
                });
            }

            const newValue = [];
            for (let i = 0; i < Math.max(1, quantity); i++) {
                for (let row of newEventData) {
                    newValue.push(row);
                }
            }

            return newValue;
        });
    }

    function add(newData) {
        let newValues = [];
        for (let i = 0; i < quantity; i++) {
            newValues.push({ clientTimezone: clientTz, ...newData });
        }

        setValue(old =>
            [...(old || []), ...newValues].filter(b => !!b?.startTime),
        );
    }

    useEffect(() => {
        update({});
    }, [quantity]);

    useEffect(() => {
        const singleEventValue = getSingleEventValue(value);

        if (settings?.hideQuantity || capacity <= 1) {
            setQuantity(1);
        } else if (quantity > 1) {
            setQuantity(Math.min(capacity, quantity));
        } else if (!!singleEventValue?.startTime) {
            // If a start time is set we're linking to something specific
            //  in that case default to 1
            const distinctQuantity =
                value?.length / getDistinctEvents(value)?.length;
            setQuantity(
                parseInt(distinctQuantity) == distinctQuantity
                    ? distinctQuantity
                    : defaultQuantity,
            );
        } else {
            // Default quantity to 0 so they explicitly pick something
            setQuantity(defaultQuantity);
        }
    }, [capacity]);

    return {
        update,
        add,
    };
}
